import { put, call, takeEvery, all } from 'redux-saga/effects'

import { FETCH_TEMPLATES, ADD_TEMPLATE, UPDATE_TEMPLATE, REMOVE_TEMPLATE } from '../actions/types'
import {
  fetchTemplates,
  fetchTemplatesSuccess,
  fetchTemplatesFailure,
  addTemplateSuccess,
  addTemplateFailure,
  updateTemplateSuccess,
  updateTemplateFailure,
  removeTemplateSuccess,
  removeTemplateFailure,
} from '../actions/elasticTemplatesActions'
import elasticService from '../services/elasticService'

function* handleFetchTemplates(action) {
  try {
    const { accessToken } = action.payload

    // Fetch data from API
    const results = yield call(elasticService.fetchTemplates, accessToken)

    yield put(fetchTemplatesSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching elastic templates')
    yield put(fetchTemplatesFailure(err))
  }
}

function* handleAddTemplate(action) {
  try {
    const { templateName, template, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.addTemplate, accessToken, templateName, template)

    // Broadcast success
    yield put(addTemplateSuccess(action.payload))

    // Fetch new templates
    yield put(fetchTemplates())
  } catch (error) {
    console.error(error, 'Error adding elastic template')
    yield put(addTemplateFailure({ error, ...action.payload }))
  }
}

function* handleUpdateTemplate(action) {
  try {
    const { templateName, template, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.updateTemplate, accessToken, templateName, template)

    // Broadcast success
    yield put(updateTemplateSuccess(action.payload))

    // Fetch new templates
    yield put(fetchTemplates())
  } catch (error) {
    console.error(error, 'Error updating elastic template')
    yield put(updateTemplateFailure({ error, ...action.payload }))
  }
}

function* handleRemoveTemplate(action) {
  try {
    const { templateName, accessToken } = action.payload

    // Fetch data from API
    yield call(elasticService.removeTemplate, accessToken, templateName)

    // Broadcast success
    yield put(removeTemplateSuccess(action.payload))

    // Fetch new templates
    yield put(fetchTemplates())
  } catch (error) {
    console.error(error, 'Error removing elastic template')
    yield put(removeTemplateFailure({ error, ...action.payload }))
  }
}

function* watchElasticTemplatesSagas() {
  yield all([
    takeEvery(FETCH_TEMPLATES, handleFetchTemplates),
    takeEvery(ADD_TEMPLATE, handleAddTemplate),
    takeEvery(UPDATE_TEMPLATE, handleUpdateTemplate),
    takeEvery(REMOVE_TEMPLATE, handleRemoveTemplate),
  ])
}

export default watchElasticTemplatesSagas
